function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2.60618,
  y: 2.48509,
  width: 50.9814,
  height: 52.5418,
  rx: 25.4907,
  stroke: "white",
  strokeWidth: 3.45797
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.2515 39.0471C33.0945 39.0471 38.4785 30.8916 38.4785 23.8201C38.4785 23.5885 38.4785 23.3569 38.4627 23.1284C39.3214 22.5076 40.0841 21.7639 40.7269 20.9256C40.7789 20.8532 40.7773 20.7555 40.7222 20.6846C40.6686 20.6137 40.5757 20.5869 40.4921 20.6184C39.7075 20.9052 38.8913 21.1021 38.0594 21.1998C39.0536 20.6058 39.8241 19.7061 40.2637 18.6441C40.2873 18.5827 40.2684 18.5133 40.2196 18.4708C40.1707 18.4282 40.0998 18.4204 40.0415 18.4519C39.093 18.9624 38.072 19.3295 37.0147 19.5391C36.0016 18.4629 34.5882 17.8516 33.1119 17.8516C30.1733 17.8516 27.7547 20.2702 27.7547 23.2088C27.7547 23.6168 27.802 24.0234 27.8934 24.4204C23.7037 24.2093 19.7883 22.2744 17.0782 19.0853C17.0293 19.027 16.9537 18.9971 16.8781 19.0049C16.8024 19.0128 16.7347 19.0585 16.7 19.1263C15.5136 21.5134 16.2762 24.474 18.5199 25.9724C17.9101 25.9535 16.9285 25.6526 16.4196 25.484C16.3455 25.4588 16.2652 25.473 16.2037 25.5202C16.1407 25.5675 16.1076 25.6431 16.1123 25.7203C16.2384 26.7902 16.8875 29.9809 20.3854 30.6159C19.7 30.8034 18.9863 30.8522 18.2851 30.7592C18.2174 30.7498 18.1496 30.7766 18.1071 30.8286C18.0645 30.8821 18.0535 30.9531 18.0771 31.0161C18.8618 33.0234 20.7935 34.3848 22.9679 34.4258C21.7153 35.409 20.2673 36.0975 18.7342 36.4489C18.2331 36.5639 17.0435 36.6317 16.1391 36.6537C16.0052 36.649 15.8854 36.7388 15.8492 36.868C15.8145 36.9988 15.8712 37.1359 15.9894 37.2021C18.2126 38.4106 20.7085 39.0471 23.2515 39.044",
  fill: "white"
});

var SvgIcTw = function SvgIcTw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-tw.f70fd96a.svg";
export { ForwardRef as ReactComponent };